(function () {
 'use strict';
 var hamburger = document.querySelector('.aurel-hamburger');
 var drawer = document.querySelector('.aurel-drawer');
 var header = document.querySelector('.aurel-header');
 var isTouch = ('ontouchstart' in window);
 function openDrawer() {
 hamburger.classList.add('is-open');
 hamburger.setAttribute('aria-expanded', 'true');
 drawer.classList.add('is-open');
 document.body.style.overflow = 'hidden';
 }
 function closeDrawer() {
 hamburger.classList.remove('is-open');
 hamburger.setAttribute('aria-expanded', 'false');
 drawer.classList.remove('is-open');
 document.body.style.overflow = '';
 }
 if (hamburger && drawer) {
 hamburger.addEventListener('click', function () {
 hamburger.classList.contains('is-open') ? closeDrawer() : openDrawer();
 });
 drawer.querySelectorAll('a').forEach(function (a) {
 a.addEventListener('click', closeDrawer);
 });
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape') closeDrawer();
 });
 }
 if (header && window.innerWidth < 1024) {
 var prevY = 0, ticking = false;
 window.addEventListener('scroll', function () {
 if (!ticking) {
 requestAnimationFrame(function () {
 var y = window.scrollY;
 if (y > prevY && y > 120 && !drawer.classList.contains('is-open')) {
 header.style.transform = 'translateY(-100%)';
 } else {
 header.style.transform = '';
 }
 prevY = y;
 ticking = false;
 });
 ticking = true;
 }
 }, { passive: true });
 header.style.transition = 'transform .3s ease';
 }
 if (isTouch) {
 document.querySelectorAll('.aurel-product-card').forEach(function (card) {
 card.addEventListener('touchstart', function () {}, { passive: true });
 });
 }
 document.querySelectorAll('.aurel-newsletter').forEach(function (form) {
 form.addEventListener('submit', function () {
 var btn = form.querySelector('button[type="submit"]');
 if (btn) setTimeout(function () { btn.textContent = 'Thank you —'; }, 80);
 });
 });
 document.documentElement.className =
 document.documentElement.className.replace('no-js', 'js');
})();